import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteAccount } from '@/hooks/useProfile';
import { useLogout } from '@/hooks/useLogout';
import { getApiErrorMessage } from '@/lib/utils/error.utils';
import { UI_STRINGS } from '@/lib/constants/ui-strings';

const P = UI_STRINGS.PROFILE;

/**
 * Danger zone card (FR-179, client-approved Option D): delete the account behind a confirm, then sign
 * out. Moved from the old `/me/edit` page (MYN-217). A failure shows inside
 * the still-open confirm, with the API's reason.
 */
export function DangerZoneCard() {
  const [isOpen, setIsOpen] = useState(false);
  const logout = useLogout();
  const deleteAccount = useDeleteAccount();

  const handleDelete = () => {
    deleteAccount.mutate(undefined, {
      onSuccess: () => {
        setIsOpen(false);
        logout();
      },
    });
  };

  return (
    <section className="rounded-card border-red/30 bg-red/5 flex flex-wrap items-center justify-between gap-4 border px-7 py-[1.375rem]">
      <div>
        <h2 className="text-navy font-sans text-[1.0625rem] font-semibold">{P.DANGER_ZONE}</h2>
        <p className="text-subtext mt-0.5 text-sm">{P.DANGER_ZONE_BODY}</p>
      </div>
      <Button variant="outline-danger" onClick={() => setIsOpen(true)}>
        {P.DELETE_ACCOUNT}
      </Button>
      <ConfirmDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        title={P.DELETE_ACCOUNT_CONFIRM_TITLE}
        description={P.DELETE_ACCOUNT_CONFIRM_BODY}
        confirmLabel={P.DELETE_ACCOUNT}
        confirmVariant="danger"
        onConfirm={handleDelete}
        isConfirming={deleteAccount.isPending}
      >
        {deleteAccount.isError && (
          <p role="alert" className="text-danger text-sm">
            {getApiErrorMessage(deleteAccount.error, P.DELETE_ACCOUNT_ERROR)}
          </p>
        )}
      </ConfirmDialog>
    </section>
  );
}
